export default "__VITE_ASSET__4nYRHSLu__"